/**
 * PWA registration + FCM deep-link hash navigation (Wave 6).
 */

let _pwaRegistered = false;

/**
 * Validate and apply a hash deep link from FCM / service worker.
 * @param {string} deepLink
 * @returns {boolean}
 */
export function applyFcmDeepLink(deepLink) {
  const link = String(deepLink || "").trim();
  if (!link.startsWith("#/")) return false;
  location.hash = link;
  return true;
}

/**
 * Purge cached shell assets on logout.
 * @returns {Promise<void>}
 */
export async function purgePwaCachesOnLogout() {
  if (typeof caches === "undefined") return;
  try {
    const keys = await caches.keys();
    await Promise.all(keys.map((k) => caches.delete(k)));
  } catch (_) {}
  try {
    if (navigator.serviceWorker && navigator.serviceWorker.getRegistration) {
      const reg = await navigator.serviceWorker.getRegistration();
      if (reg) await reg.unregister();
      _pwaRegistered = false;
    }
  } catch (_) {}
}

/**
 * Register the service worker once after authenticated boot.
 * @returns {Promise<void>}
 */
export async function registerPwaServiceWorker() {
  if (_pwaRegistered) return;
  if (typeof navigator === "undefined" || !navigator.serviceWorker) return;
  try {
    const reg = await navigator.serviceWorker.register("public/sw.js", { scope: "public/" });
    _pwaRegistered = true;
    navigator.serviceWorker.addEventListener("message", (ev) => {
      const data = ev.data || {};
      if (data.type === "croc-fcm-deep-link") {
        applyFcmDeepLink(data.deep_link);
      }
    });
    if (reg && reg.active) {
      /* warm registration */
    }
  } catch (_) {
    /* PWA optional — console works without SW */
  }
}
